import styled from "styled-components/macro";

export const StyledBrainform = styled.div`
  button {
    float: right;
    margin-right: 5px;

  }

  .required {
    label {
      color: var(--grey-0);
    }
    textarea {
      border: 1.5px solid var(--grey-2);
      outline: 3px solid transparent;
      &:focus {
        border: 1.5px solid transparent;
        outline: 3px solid var(--primary-cta-hover);
      }
    }
  }

  textarea {
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 10px;
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    resize: none;
    background: var(--menu-color);
    color: var(--grey-0);
    border: 1.5px solid var(--grey-2);
    outline: 3px solid transparent;
    ::selection {
      background: var(--text-highlight);
    }

    &:focus {
      border: 1.5px solid transparent;
      outline: 3px solid var(--primary-cta-hover);
    }
  }

  label {
    font-family: "Inter";
    margin-top: 10px;
    margin-bottom: 2px !important;
    text-transform: none !important;
    font-size: 15px;
    color: var(--grey-1);
  }
`;

export const StyledStartOver = styled.a`
  float: right;
  padding: 23px;
  color: #7205d6;
`;

export const StyledBrainPuppet = styled.div`
  float: right;
  margin-top: -70px;
  width: 120px;
  height: 120px;

  svg {
    width: inherit;
    height: inherit;
  }
`;

export const StyledH3s = styled.div`
  h3 {
    color: var(--grey-1);
    font-family: "Inter";
    font-weight: normal;
    line-height: 1.3;
    margin-bottom: 0;
  }
  margin-bottom: 30px;
`;
